module.exports = __webpack_public_path__ + "fonts/Manrope-Medium.73d4c7c9.ttf";